import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RidersRoutingModule } from './riders-routing.module';
import { RiderComponent } from './rider.component';
import { CreateComponent } from './components/create/create.component';
import { Trip2ThemeModule } from '../../trip2-theme/trip2-theme.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { MyDatePickerModule } from 'mydatepicker';
import { RiderNotesModule } from './rider-notes/rider-notes.module';
import { PayorModalComponent } from './components/payor-modal/payor-modal.component';
import { AutoCompleteFacilitiesModule } from '../A2-utils/auto-complete-facilities/auto-complete-facilities.module';
import { T2AutoCompleteLocationModule } from '../A2-utils/t2-autocomplete-location/t2-autocomplete-location.module';
import { RiderHistoryModule } from './rider-history/rider-history.module';
import {GridComponentsModule} from '../A2-utils/grid-components/grid-components.module';
import {BooleanCheckComponent} from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import {TextMaskModule} from 'angular2-text-mask';
import { SearchLocationTripModule } from '../A2-utils/search-location-trip/search-location-trip.module';
import { MobileAppComponent } from './mobile-app/mobile-app.component';
import {ChangePasswordModule} from '../A2-utils/change-password/change-password.module';
import {MergeAccountModule} from '../merge-account/merge-account.module';
import { DirectivesModule } from 'app/directives/directives.module';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';


@NgModule({
    imports: [
        CommonModule,
        RidersRoutingModule,
        Trip2ThemeModule,
        FormsModule,
        ReactiveFormsModule,
        MyDatePickerModule,
        RiderNotesModule,
        RiderHistoryModule,
        TextMaskModule,
        T2AutoCompleteLocationModule,
        AutoCompleteFacilitiesModule,
      ChangePasswordModule,
        AgGridModule.withComponents([
          BooleanCheckComponent
            // DropDownIsDefaultRender
        ]),
        GridComponentsModule,
        SearchLocationTripModule,
        DirectivesModule,
      MergeAccountModule
    ],
    declarations: [RiderComponent, CreateComponent, PayorModalComponent, MobileAppComponent],
    exports: [RiderComponent, CreateComponent, PayorModalComponent, MobileAppComponent],
    providers: [
      T2LoadingService
    ]
})
export class RidersModule { }



// WEBPACK FOOTER //
// ./src/app/pages/riders/riders.module.ts